import {useState,useEffect,useRef} from "react";
import {Link} from "react-router-dom";
import ImageGallery from "react-image-gallery";
import type { GalleryItem, ImageGalleryRef } from "react-image-gallery";
import "react-image-gallery/styles/image-gallery.css";

// -- biz9 --
import {Log,Num,Str} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Image} from "../../../project";
const Modal_Image_More_Slide_Show = (props) => {
    const [val_sub_page_title,setValSubPageTitle] =  useState('Slide Show');
    const [val_title,setValTitle] = useState("Item " + Str.get_id());
    const [showModal, setShowModal] = useState(true);
    const [images, setImages] = useState([]);
    useEffect(() => {
            if(props){
            get_data(props);
            }
            },[props]);
    async function get_data(data){
        bind_image(data);
    };
    async function bind_image(data){
        data.images.map((image) => {
                image.original = Image.get_url(image.image_filename,Image_Format.ORIGINAL);
                image.thumbnail = Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB);
                image.loading = 'lazy';
                image.lazyLoad = true;
                });
        setImages(data.images);
    };
    const galleryRef = useRef<ImageGalleryRef>(null);
    return (
            <>
            {/* Item */}
            <div className="modal new-modal fade" id="modal_more_slide_show" data-keyboard="false" data-backdrop="static">
            <div className="modal-dialog modal-dialog-centered"  style={{ width: '100%', maxWidth: '100%' }}>
            <div className="modal-content">
            <div className="modal-header" >
            <button type="button" className="close-btn" data-bs-dismiss="modal">
            <span>×</span>
            </button>
            </div>
            <div className="modal-body">
            <ImageGallery
            ref={galleryRef}
            items={images}
            onSlide={(index) => console.log("Slid to", index)}
            />
            </div>
                </div>
                </div>
                </div>
                </>
                );
};
export default Modal_Image_More_Slide_Show;
